import { useInstantSearch } from "react-instantsearch";
import { useSearchUrlSync } from "@/hooks/use-search-url-sync";
import {
  MARKETPLACE_CONTINUOUS_KEYS,
  MARKETPLACE_SEARCH_PARAM_KEYS,
  serializeMarketplaceSearchParams,
} from "./search-params";

/** Renderless writer mirroring the marketplace InstantSearch state into the URL. */
export function MarketplaceUrlSync() {
  const { indexUiState } = useInstantSearch();
  useSearchUrlSync({
    params: serializeMarketplaceSearchParams(indexUiState),
    ownedKeys: MARKETPLACE_SEARCH_PARAM_KEYS,
    continuousKeys: MARKETPLACE_CONTINUOUS_KEYS,
  });
  return null;
}
